import React, { useState } from 'react';
import { InformePericial } from '../../types';
import { informeService } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiFileText, FiDownload } from 'react-icons/fi';
import './EncargoForm.css';

interface CerradoInformeProps {
    informe?: InformePericial;
    onUpdate: (informe: InformePericial) => void;
}

const CerradoInforme: React.FC<CerradoInformeProps> = ({ informe }) => {
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const prvHandleDownloadDocx = async () => {
        if (!informe) return;
        setError('');
        try {
            const response = await informeService.descargarDocx(informe.id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Informe_${informe.numero_expediente}.docx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err: any) {
            console.error('Error al descargar DOCX:', err);
            setError(err.response?.data?.error || 'Error al descargar el archivo DOCX');
        }
    };

    const prvHandleDownloadPdf = async () => {
        if (!informe) return;
        setError('');
        try {
            const response = await informeService.generarPDF(informe.id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Informe_${informe.numero_expediente}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err: any) {
            console.error('Error al descargar PDF:', err);
            setError(err.response?.data?.error || 'Error al descargar el archivo PDF');
        }
    };

    return (
        <div className="encargo-form items-center justify-center py-12">
            {error && <div className="error-message mb-4" style={{ color: '#ef4444', backgroundColor: '#fef2f2', padding: '10px', borderRadius: '6px', border: '1px solid #fee2e2', width: '100%', maxWidth: '2xl', boxSizing: 'border-box' }}>{error}</div>}
            <div className="text-center max-w-2xl mx-auto">
                <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-100 text-green-600 mb-6">
                    <span className="text-5xl"><FiCheckCircle /></span>
                </div>

                <h2 className="text-3xl font-bold text-gray-900 mb-4">Expediente Cerrado</h2>
                <p className="text-lg text-gray-600 mb-8">
                    El informe pericial ha sido completado y enviado correctamente.
                    El expediente {informe?.numero_expediente} se encuentra cerrado.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={prvHandleDownloadDocx}
                        className="btn btn-outline flex items-center gap-2 justify-center px-6 py-3"
                    >
                        <span><FiFileText /></span> Descargar DOCX
                    </button>
                    <button
                        onClick={prvHandleDownloadPdf}
                        className="btn btn-outline flex items-center gap-2 justify-center px-6 py-3"
                    >
                        <span><FiDownload /></span> Descargar PDF
                    </button>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200">
                    <button
                        onClick={() => navigate('/')}
                        className="btn btn-primary px-8"
                    >
                        Volver al Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CerradoInforme;
